import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<g transform=\"translate(-11 -11)\"><g fill=\"none\" stroke=\"#585858\" data-name=\"Ellipse 23\" transform=\"translate(11 11)\"><circle cx=\"6\" cy=\"6\" r=\"6\" stroke=\"none\"></circle><circle cx=\"6\" cy=\"6\" r=\"5.5\"></circle></g><circle cx=\"3\" cy=\"3\" r=\"3\" fill=\"currentColor\" data-name=\"Ellipse 22\" transform=\"translate(14 14)\"></circle></g>", 1)
  ]))]))
}
export default { render: render }